export default function () {
  return {
    leftDrawerOpen: false,
    signUpInfo: {
        full_name: '',
        email: '',
        message_time_of_day: '',
    },
    dob_required: false,
    messages: [],
    videos: [],
    settings: {
      about_us_text: '',
      contact_us_text: '',
      DONATE_LINK: 'https://givealittle.co.nz/org/voices-of-hope',
      CONTACTS_LINK: 'https://checkpointorg.com/global/',
    },
    notifications: 0,
    user: {
      id: 0,
      full_name: '',
      email: '',
      email_verified_at: '',
      is_admin: false,
      is_active: false,
      comment: '',
      img: '',
      message_time_of_day: ''
    },
  }
}
